import React from "react";
import "./PrivacyPolicy2.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-card">
        <h1>Privacy Policy</h1>
        <p className="status-text">
          Privacy Policy under development
        </p>
        <p className="sub-text">
          This page will be live soon. Please wait.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
